import tw from "twin.macro";
import styled from "styled-components";

const Base = styled.p(tw`font-montserrat pb-0 mb-0`);

export const XSmall = styled(Base)(tw`text-2xs leading-4`);
export const Small = styled(Base)(tw`text-xs`);
export const Medium = styled(Base)(tw`text-base`);
export const Large = styled(Base)(tw`text-lg font-medium`);
